import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Tooltip, Typography } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import PublishIcon from '@material-ui/icons/Publish';
import CloseIcon from "@material-ui/icons/Close";
import { Delete } from "@material-ui/icons";
import { toast } from "react-toastify";
import { usePostReportTemplateUpload } from '../../../common/services/fileServices';
import { useFetchContext } from '../../../common/FetchContext';

export const FileUploadApprover = ({ report_id, work_order_id, refetch}: any) => {

    const { authAxios } = useFetchContext();
    const { mutateAsync: mutatePostFile, isLoading: isLoadingFileUpload } = usePostReportTemplateUpload();

    const [open, setOpen] = useState(false);
    const [currentDate, setCurrentDate] = useState(new Date());
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [files, setFiles] = React.useState<any[]>([]);


    const handleToggle = () => {
        if (!open) {
            setCurrentDate(new Date());
        } else{
            setFiles([]);
        }
        setOpen(!open);
    };

    const handleFileUpload = async (item: any) => {
        console.log(item)
        fileInputRef.current?.click()
    };

    const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles) {
            setFiles(uploadedFiles as any);
        }

    };

    const handleSubmit = async () => {


        if (!files.length) {
            toast.error("Please upload a file before submitting.");
            return;
        }

        const file = files[0];
        const currentdatetime = currentDate.toISOString();

        try {
            await mutatePostFile({
                authAxios,
                file,
                report_id,
                workorder_id:work_order_id,
                datetime: currentdatetime,
            });
            toast.success("File uploaded successfully!");


            await refetch();

            handleToggle();
            setFiles([]);



        } catch (error: any) {
            console.error(error);
            toast.error(error?.message);
        }




    }

    return (
        <div>

            <Tooltip title="File Upload">
                <IconButton
                    onClick={handleToggle}
                >
                    <PublishIcon color="primary" />

                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleToggle}
                aria-labelledby="dialog-title"
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Final File Upload for Approver</Typography>
                        <IconButton onClick={handleToggle}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </DialogTitle>

                <Divider />

                <DialogContent dividers>
                    <Grid container spacing={3}>

                        <Grid item xs={9}>
                            <Grid item xs={12}>
                                <Typography variant="h5" color="primary" >Upload Report File <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30" /></Typography>
                            </Grid>
                            <Grid item xs={4}>

                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={handleFilePicked}
                                />
                                {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                                    <img src="/file_icon.png" alt="Custom Icon" height={200} width={200} />
                                    <IconButton
                                        style={{
                                            position: "absolute",
                                            top: "5px",
                                            right: "5px",
                                            background: "lightgray",
                                            color: "black",
                                            border: "none",
                                            borderRadius: "50%",
                                            width: "40px",
                                            height: "40px",
                                        }}
                                        onClick={() => setFiles([])}
                                    >
                                        <Delete></Delete></IconButton>
                                </div>}
                            </Grid>

                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleToggle} color="secondary" variant="outlined">
                        Close
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={isLoadingFileUpload}
                    >
                        {isLoadingFileUpload ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "upload File"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}


